/*
 * Jira Ticket:
 * Created Date: Wed, 19th Jan 2022, 19:16:36 pm
 * Author: Mark Wilkinson
 * Email: mark.wilkinson@thedistance.co.uk
 * Copyright (c) 2022 The Distance
 */

import { fetchStart, fetchEnd } from 'react-admin';

export default function getHelp(key, { dataProvider, dispatch, setHelpLink }) {
  return () => {
    let isSubscribed = true;
    dispatch(fetchStart());
    dataProvider('GET_ONE', 'Configuration', { id: key })
      .then(result => {
        if (isSubscribed) {
          setHelpLink(result?.data?.value);
        }
      })
      .catch(() => {})
      .finally(() => {
        dispatch(fetchEnd());
      });

    return () => (isSubscribed = false);
  };
}
